import React from 'react';
import { Button, Layout } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import logoImage from '../../assets/LOGO_DX_PNG.png';
import './Navbar.css';
import { LeftOutlined, LoginOutlined } from '@ant-design/icons';
import { useLanguage } from '../../contexts/LanguageContext';

const { Header } = Layout;

interface NavbarProps {
  onBack?: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ onBack }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { language, toggleLanguage } = useLanguage();

  const handleLogoClick = () => {
    navigate('/');
  };

  const handleBackClick = () => {
    if (onBack) {
      onBack();
    } else {
      navigate("/main");
    }
  };

  const isDetailPage = location.pathname.startsWith('/detail/');
  const isRootPath = location.pathname === '/';

  return (
    <Header className="navbar navbar--transparent">
      <div className="navbar-content">
        <div className="logo" onClick={handleLogoClick}>
          <img
            src={logoImage}
            alt="DX Logo"
            className="logo-image"
            style={{ height: '109px', width: 'auto' }}
          />
        </div>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          {(isDetailPage || onBack) && (
            <Button
              type="primary"
              size="large"
              className="back-button"
              onClick={handleBackClick}
              icon={
                <div style={{
                  backgroundColor: 'white',
                  borderRadius: '50%',
                  width: '24px',
                  height: '24px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                  <LeftOutlined style={{ fontSize: '12px' }} />
                </div>
              }
              iconPosition='start'
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                minWidth: '120px',
              }}
            >
              <span style={{ textAlign: 'center', flex: 1 }}>
                {language === 'TH' ? 'กลับ' : 'Back'}
              </span>
            </Button>
          )}
          
          <div className="language-toggle" onClick={toggleLanguage} style={{ marginTop: (isDetailPage || onBack ? '72px' : '8px') }}>
            <div className="language-toggle-content">
              <span className={`language-option ${language === 'TH' ? 'active' : 'inactive'}`}>
                TH
              </span>
              |
              <span className={`language-option ${language === 'EN' ? 'active' : 'inactive'}`}>
                EN
              </span>
            </div>
          </div>

          {isRootPath && (
            <Button
              type="text"
              size="large"
              icon={<LoginOutlined />}
              onClick={() => navigate('/admin')}
              style={{
                color: 'black',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                marginTop: (isDetailPage || onBack ? '72px' : '8px'),
              }}
              className="admin-login-button"
            >
              Admin Login
            </Button>
          )}
        </div>
      </div>
    </Header>
  );
};

export default Navbar;
